// Whether the worker a task was routed to has a GPU. Decided by the API, which is the only
// place that knows the routing rules, and sent back on the work request response.
var WorkerGpuType = {
  GPU: 'gpu',
  NON_GPU: 'non-gpu'
};
export default WorkerGpuType;